import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch , handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    selectInfoRealPdf: "selectInfoRealPdf [Action]",
    selectInfoRealPdfLoading: "selectInfoRealPdfLoading [Action]",
    selectInfoRealPdfAsync: "selectInfoRealPdfAsync [Action]",
};

const inistiaState = {
    data: {},
    total:0,
    loading: false
};

export const reducerSelectInfoRealPdf = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectInfoRealPdf:
            return {
                ...state,
                data: payload.image_file,
                total: payload.image_file ? Object?.keys(payload.image_file)?.length :0
            };
        case actionTypes.selectInfoRealPdfLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectInfoRealPdfLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "brokercustomer",
        method_type: "select_info_real_pdf",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectInfoRealPdf, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectInfoRealPdfLoading, payload: false })

    }
}

export function* workerSelectInfoRealPdf() {
    yield takeLatest(actionTypes.selectInfoRealPdfAsync, handleWorker);
}
